import { useEffect, useState } from 'react';
import api from './api';

/**
 * Visor de un documento archivado (PDF).
 *
 * NO se puede usar <iframe src="/v1/documentos/{id}/archivo">: el navegador no manda
 * la cabecera Authorization en el pedido que dispara ese <iframe>, así que el backend
 * respondería 401 y el visor quedaría en blanco. En su lugar se baja el archivo como
 * blob con axios (que sí manda el Bearer token vía el interceptor de api.js), se arma
 * un object URL en memoria del navegador, y RECIÉN ese URL -que no necesita cabeceras,
 * el blob ya está descargado- se pasa al <iframe>. Se revoca al desmontar para no
 * retener el PDF (que puede llevar cédula, dirección y firma) en memoria más de lo
 * necesario.
 */
export default function Visor({ documentoId, onClose, onSesionExpirada }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    let objectUrl = null;
    let cancelado = false;

    setCargando(true);
    setError('');
    setUrl(null);

    api.get(`/documentos/${documentoId}/archivo`, { responseType: 'blob' })
      .then((r) => {
        if (cancelado) return;
        objectUrl = URL.createObjectURL(r.data);
        setUrl(objectUrl);
      })
      .catch((e) => {
        if (cancelado) return;
        const status = e.response?.status;
        if (status === 401) { onSesionExpirada?.(); return; }
        setError(
          status === 404 ? 'Documento no encontrado.' :
          status === 410 ? 'El archivo ya no está disponible en el almacenamiento.' :
          status === 409 ? 'El archivo no coincide con su hash registrado.' :
          'No se pudo abrir el documento.'
        );
      })
      .finally(() => { if (!cancelado) setCargando(false); });

    return () => {
      cancelado = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [documentoId, onSesionExpirada]);

  return (
    <div className="nv-modal-overlay" onClick={onClose}>
      <div
        className="nv-modal"
        style={{ maxWidth: 920, width: '95%', height: '85vh', display: 'flex', flexDirection: 'column' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="nv-modal-header">
          <span className="nv-modal-title">Documento</span>
          <button className="nv-modal-close" onClick={onClose} aria-label="Cerrar">×</button>
        </div>
        <div style={{ flex: 1, minHeight: 0, overflow: 'hidden', borderRadius: 'var(--r-md)', background: 'var(--bg-base)' }}>
          {cargando && (
            <div className="nv-loading" style={{ height: '100%' }}>
              <span className="nv-spinner" />
              Cargando documento…
            </div>
          )}
          {!cargando && error && (
            <div style={{ padding: 20 }}>
              <div className="nv-alert nv-alert-err">{error}</div>
            </div>
          )}
          {!cargando && !error && url && (
            <iframe title="Documento archivado" src={url} style={{ width: '100%', height: '100%', border: 'none' }} />
          )}
        </div>
      </div>
    </div>
  );
}
